import { errorToast } from '@app/utils/notifications'
import { connect } from 'react-redux'
import EditPageContainer, { IComponentProps } from './EditPageContainer'

export default connect((state, ownProps: IComponentProps) => ownProps, {
  errorToast,
})(EditPageContainer)
